import React from "react"
import * as styles from "./applyModal.module.scss"
import Modal from "../modal"
import ApplyContent from "./ApplyContent"

const ApplyModal = React.memo((props) => {
  return (
    <Modal red {...props}>
      <div className={styles.container}>
        <ApplyContent />
      </div>
    </Modal>
  )
})

ApplyModal.displayName = "ApplyModal"
export default ApplyModal
